import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { VmAdminEventsResponse } from '@/types/dtos/vm/response/vm-admin.dto';

export const GET_VM_EVENTS_QUERY_KEY = 'get-vm-events-admin';

export const useGetVmEventsQuery = (vmId: string | null, limit = 50) => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [GET_VM_EVENTS_QUERY_KEY, vmId, limit],
    queryFn: async () => {
      const token = await getToken();
      return getVmEvents(token ?? '', vmId!, limit);
    },
    enabled: !!vmId,
    retry: false,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
};

const getVmEvents = async (token: string, vmId: string, limit: number): Promise<VmAdminEventsResponse> => {
  const url = `${import.meta.env.VITE_API_URL}/vm/${vmId}/events?limit=${limit}`;
  return (await sendJSONRequest({ url, method: METHOD.GET, token })) as VmAdminEventsResponse;
};
